import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Nav, NavItem, NavLink, TabContent, TabPane, Badge } from "reactstrap";
import groupBy from "lodash/groupBy";

import Tile, { TileTitle, TileHeader, TileBody } from "shared/react_components/Tile";
import IconWithTooltip from "shared/react_components/IconWithTooltip";
import { iconStyle } from "../styles/SignalsData.module.scss";
import classNames from "classnames";

const SignalsData = ({ evaluatedSignals }) => {
  const [activeTab, setActiveTab] = useState("signalsMet");
  const groupedSignals = useMemo(() => groupBy(evaluatedSignals, "result"), [evaluatedSignals]);

  return (
    <Tile>
      <TileHeader>
        <TileTitle>Signals</TileTitle>
      </TileHeader>
      <TileBody>
        <Nav tabs style={{ borderBottomWidth: 0 }}>
          <NavItem>
            <NavLink active={activeTab === "signalsMet"} onClick={() => setActiveTab("signalsMet")}>Signals Met</NavLink>
          </NavItem>
          <NavItem>
            <NavLink active={activeTab === "signalsNotMet"} onClick={() => setActiveTab("signalsNotMet")} >Signals Not Met</NavLink>
          </NavItem>
          <NavItem>
            <NavLink active={activeTab === "signalsNotApplied"} onClick={() => setActiveTab("signalsNotApplied")} >Signals Not Applied</NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={"signalsMet"} >
            {groupedSignals.MET
              ? (groupedSignals.MET).map(signal => (
                <p key={signal.name}>
                  {signal.source === "UserOverride"
                    ? <IconWithTooltip icon="thumb_up" className={iconStyle}>Updated to True</IconWithTooltip>
                    : <IconWithTooltip icon="check_circle" className={classNames("text-success", iconStyle)}>True</IconWithTooltip>
                  }
                  {signal.name}
                  {signal.types && (signal.types.map(badge => (
                    <Badge key={badge} className="ml-2">{badge}</Badge>
                  )))}
                </p>))
              : <p>None</p>
            }
          </TabPane>
          <TabPane tabId={"signalsNotMet"}>
            {groupedSignals.UNMET
              ? groupedSignals.UNMET.map(signal => (
                <p key={signal.name}>
                  {signal.source === "UserOverride"
                    ? <IconWithTooltip icon="thumb_down" className={iconStyle}>Updated to False</IconWithTooltip>
                    : <IconWithTooltip icon="close" className={classNames("text-danger", iconStyle)}>False</IconWithTooltip>
                  }
                  {signal.name}
                  {signal.types && (signal.types.map(badge => (
                    <Badge key={badge} className="ml-2">{badge}</Badge>
                  )))}
                </p>))
              : <p>None</p>
            }
          </TabPane>
          <TabPane tabId={"signalsNotApplied"}>
            {groupedSignals.NOT_APPLIED
              ? groupedSignals.NOT_APPLIED.map(signal => (
                <p key={signal.name}>
                  <IconWithTooltip icon="remove_circle_outline" className={iconStyle}>Signals not applied</IconWithTooltip>
                  {signal.name}
                  {signal.types && (signal.types.map(badge => (
                    <Badge key={badge} className="ml-2">{badge}</Badge>
                  )))}
                </p>))
              : <p>None</p>
            }
          </TabPane>
        </TabContent>
      </TileBody>
    </Tile>
  );
};

SignalsData.propTypes = {
  evaluatedSignals: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      result: PropTypes.string.isRequired,
      types: PropTypes.array.isRequired,
      source: PropTypes.string
    })).isRequired
};

export default SignalsData;
